import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const createCoupon = async (couponData) => {
  try {
    const config = await getAuthConfig();
    const response = await api.post("/createCoupon", couponData, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllCoupons = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllCoupons", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCoupon = async (id, updates) => {
  try {
    const config = await getAuthConfig();
    const response = await api.put(`/updateCoupon/${id}`, updates, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCoupon = async (id) => {
  try {
    const config = await getAuthConfig();
    const response = await api.delete(`/deleteCoupon/${id}`, config);
    return response;
  } catch (error) {
    throw error;
  }
};
